import { useCallback } from "react"
import { graphql, useMutation } from "react-relay"
import {
  TryToReassignAgentInput,
  useTryToReassignAgentMutation as tryToReassignAgentMutation,
  useTryToReassignAgentMutation$data,
} from "@/modules/waiting-room/services/__generated__/useTryToReassignAgentMutation.graphql"

const mutation = graphql`
  mutation useTryToReassignAgentMutation($input: TryToReassignAgentInput!) {
    tryToReassignAgent(input: $input) {
      appointment {
        appointmentId
        appointmentType
        assignedTo
        id
        service
        specialty
      }
      errors {
        ... on AppointmentNotFound {
          __typename
          message
        }
        ... on NoSuitableAgentFound {
          __typename
          message
        }
        ... on AppointmentIsNotAutomaticallyReassignable {
          __typename
          message
        }
        ... on FeatureIsDisabledDuringDayLightSavingTime {
          __typename
          message
        }
      }
    }
  }
`

export type TryToReassignAgentError = NonNullable<
  useTryToReassignAgentMutation$data["tryToReassignAgent"]["errors"]
>[number]["__typename"]

export function useTryToReassignAgentMutation() {
  const [commit] = useMutation<tryToReassignAgentMutation>(mutation)

  return useCallback(
    (
      input: TryToReassignAgentInput,
      handleCompleted?: ((response: useTryToReassignAgentMutation$data) => void) | undefined,
    ) => {
      commit({
        variables: {
          input,
        },
        onCompleted: handleCompleted,
      })
    },
    [commit],
  )
}
